import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";
import { saveVoucherType } from "./index";
import { voucherApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getVoucherTypeSaga() {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(voucherApi.getVoucherTypes);

		if (response.data.result) {
			yield put(saveVoucherType(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveVoucherType(null, true, resultError.messagesDataError));
		}
	}
}
